<template>
  <div class="">
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <!-- IP Filter -->
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg("IP Address") }}</label>
            <b-form-input v-model="filter.like.ipAddress" class="d-inline-block mr-1"/>
          </b-col>

          <!-- Location Filter -->
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg("Location") }}</label>
            <b-form-input v-model="filter.like.location" class="d-inline-block mr-1"/>
          </b-col>

          <!-- Status Filter -->
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg('Status') }}</label>
            <v-select
                v-model="filter.in.status"
                :options="keyboxStatus"
                class="w-100"
                label="text"
                :reduce="(status) => status.value"
                multiple
            />
          </b-col>

          <!-- Installation Status Filter -->
          <b-col cols="12" md="3" class="mb-md-0 mb-2">
            <label>{{ msg('Installation Status') }}</label>
            <v-select
                v-model="filter.in.installationStatus"
                :options="installationStatuses"
                class="w-100"
                label="text"
                :reduce="(status) => status.value"
                multiple
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!--Keybox Table-->
    <b-card no-body>
      <div class="card-header" style="overflow: hidden">
        <i class="fas fa-key" style="margin-right: 3px"></i>
        <span class="card-title m-0">{{ msg('Keyboxes') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="refresh()">
              <feather-icon icon="RefreshCcwIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </div>

      <!--Card Content-->
      <b-card-body>
        <b-row no-gutters class="mb-1">
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ msg('Show') }}</label>
            <v-select
                v-model="page.amount"
                :options="[10, 25, 50, 100]"
                :clearable="false"
                @option:selected="refresh"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ msg('entries') }}</label>
          </b-col>
          <!-- New Keybox -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-button variant="primary" @click="onNewKeybox(0)">
                <i class="fas fa-key" style="margin-right: 2px"></i>
                <span class="text-nowrap">{{ msg('New Keybox') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <!--Table-->
        <b-table
            ref="keybox-table"
            striped
            hover
            responsive
            v-bind:items="keyboxes"
            v-bind:fields="fields"
            :busy="loading"
            @row-clicked="onRowClick"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mx-1"></b-spinner>
              <strong>{{ msg('Loading') }}...</strong>
            </div>
          </template>


          <template #cell(realEstateIds)="data">
            <div>
              <b-button
                  size="sm"
                  variant="link"
                  @click="toggleVisibleRow(data.index)"
                  class="p-0"
              >
                {{ visibleRows[data.index] ? msg('Hide') : msg('Show') }} {{ msg('Rooms') }} ({{ data.value.length }})
              </b-button>

              <b-collapse :id="'property-collapse-' + data.index" :visible="visibleRows[data.index]">
                <ul class="mt-2 mb-0 pl-3">
                  <li
                      v-for="propertyId in data.value"
                      :key="propertyId"
                      style="white-space: nowrap;"
                  >
                    {{ realEstates[propertyId].name || propertyId }}
                  </li>
                </ul>
              </b-collapse>
            </div>
          </template>

          <template #cell(buildingId)="data">
            <b-link style="font-weight: bold" v-if="data.value!=null && data.value!==''"
                    @click="routeToBuilding(data.value)" variant="danger">
              {{ buildings[data.value]!=null?buildings[data.value].address: "Unknown" }}
            </b-link>
          </template>

          <template #cell(imageUri)="data">
              <b-img v-if="data.item.totalCompartments===12" :src="require('@/assets/images/elements/slots12.jpg')" fluid thumbnail style="max-width: 70px; max-height: 70px"/>
              <b-img v-else-if="data.item.totalCompartments===24" :src="require('@/assets/images/elements/slots24.jpg')" fluid thumbnail style="max-width: 70px; max-height: 70px"/>
              <b-img v-else :src="require('@/assets/images/elements/slots36.jpg')" fluid thumbnail style="max-width: 70px; max-height: 70px"/>
          </template>

          <!-- Status -->
          <template #cell(status)="data">
            <b-badge :variant="statusVariants[data.value]">{{ msg(data.value) }}</b-badge>
          </template>

          <!-- Installation Status -->
          <template #cell(installationStatus)="data">
            <b-badge variant="secondary">{{ msg(data.value) }}</b-badge>
          </template>

          <!-- Actions -->
          <template #cell(actions)="row">
            <b-button
                size="sm"
                @click="openConfirmationModal('delete', row.item)"
                class="btn btn-danger mr-1"
                v-b-tooltip.hover
                :title="msg('Delete')"
            >
              <i class="fa fa-trash" aria-hidden="true"></i>
            </b-button>
          </template>
        </b-table>

        <!-- Pagination -->
        <div class="text-center w-100">
          <div class="d-inline-block">
            <b-pagination
                v-model="page.currentPage"
                :total-rows="page.total"
                :per-page="page.amount"
                first-number
                last-number
                @input="refresh"
            />
          </div>
          <div class="d-inline-block px-2"><strong>{{ msg('Total') }}</strong> {{ page.total }}</div>
        </div>
      </b-card-body>
    </b-card>

    <!-- Modals -->
    <b-modal no-fade v-model="dialogs.newKeybox" size="lg" ref="keybox-modal" id="keybox-modal"
             :hide-footer="true" no-close-on-backdrop centered>
      <keybox-panel ref="keyboxPanel" @submitted="onSubmitted"/>
    </b-modal>
    <b-modal no-fade v-model="dialogs.updateKeybox" size="xl" ref="edit-keybox-modal" id="edit-keybox-modal"
             :hide-footer="true" no-close-on-backdrop centered>
      <edit-keybox-panel ref="editKeyboxPanel" @submitted="onSubmitted" :id="selected"/>
    </b-modal>

    <!-- Confirmation -->
    <b-modal v-model="showConfirmationModal"
             :title="msg('Confirm Action')"
             @cancel="closeModal"
             centered
             :cancel-title="msg('Cancel')"
             ok-variant="success"
             cancel-variant="danger"
             @ok="confirmAction">
      <p>{{ modalMessage }}</p>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import KeyboxPanel from "./keyboxPanel.vue";
import EditKeyboxPanel from "@/views/realEstate/keybox/editKeyboxPanel.vue";

export default {
  name: 'Keyboxes',
  components: {KeyboxPanel, EditKeyboxPanel},
  data() {
    return {
      loading: true,
      keyboxes: [],
      realEstates: {},
      fields: [],
      selected: null,
      buildings: {},
      showConfirmationModal: false,
      modalMessage: '',
      modalEvent: '',
      selectedItem: null,
      visibleRows: {},
      filter: {
        like: {ipAddress: '', location: ''},
        in: {status: [], installationStatus: []}
      },
      sort: {by: 'creationDate', direction: 'desc'},
      page: {amount: 10, currentPage: 1, total: 0},
      dialogs: {newKeybox: false, updateKeybox: false},
      installationStatuses: [
        { value: 'installed', text: 'Installed' },
        { value: 'pending', text: 'Pending' },
        { value: 'failed', text: 'Failed' }
      ],
      statusVariants: {
        "online": "success",
        "offline": "secondary",
        "inProgress": "warning",
        "error": "danger"
      }
    }
  },
  created() {
    this.setFields();
    this.refresh();
    this.$root.$on('crm::submitBusinessUnit', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitBusinessUnit', this.listeners.submit)
  },
  computed: {
    ...mapGetters('translator', ['msg']),
    ...mapGetters('keybox', ['allKeyboxStatus']),
    keyboxStatus() {
      return this.allKeyboxStatus.map(status => ({
        value: status.value,
        text: this.msg(status.text)
      }))
    },
  },

  methods: {
    ...mapActions('keybox', ['getAllKeyboxs', 'deleteService']),
    toggleVisibleRow(index) {
      this.$set(this.visibleRows, index, !this.visibleRows[index]);
    },
    routeToBuilding(eventId) {
      window.open(`/building/edit/${eventId}`, '_blank');
    },
    setFields() {
      this.fields = [
        {key: 'imageUri', label: this.msg('Image'), sortable: false},
        {key: 'serialNumber', label: this.msg('Serial Number'), sortable: false},
        {key: 'buildingId', label: this.msg('Building'), sortable: false},
        {key: 'ipAddress', label: this.msg('IP Address'), sortable: true},
        {key: 'totalCompartments', label: this.msg('Slots'), sortable: true},
        {key: 'location', label: this.msg('Location'), sortable: true},
        {key: 'status', label: this.msg('Status'), sortable: true},
        {key: 'installationStatus', label: this.msg('Installation Status'), sortable: true},
        {key: 'realEstateIds', label: this.msg('Rooms'), sortable: false},
       // {key: 'actions', label: this.msg('Actions'), sortable: false}
      ]
    },
    refresh() {
      this.loading = true;
      this.getAllKeyboxs({
        page: this.page.currentPage,
        amount: this.page.amount,
        filter: this.filter,
        sortcolumn: this.sort.by,
        sortby: this.sort.direction,
      }).then(this.onKeyboxesRetrieve, (error) => this.error = error)
    },
    onKeyboxesRetrieve(data) {
      this.page = {amount: data['Amount'], total: data['Total'], currentPage: data['Page']};
      this.keyboxes = data["Keyboxs"];
      this.realEstates = data["RealEstates"];
      this.buildings = data["Buildings"];
      this.loading = false;
    },
    onNewKeybox() {
      this.dialogs.newKeybox = true;
    },
    onRowClick(keybox) {
      this.selected = keybox.id;
      this.dialogs.updateKeybox = true;
    },
    openConfirmationModal(event, item) {
      this.modalEvent = event;
      this.selectedItem = item;
      if (event === 'delete') {
        this.modalMessage = this.msg('Are you sure you want to delete this keybox?');
      }
      this.showConfirmationModal = true;
    },
    closeModal() {
      this.showConfirmationModal = false;
    },
    confirmAction() {
      if (this.modalEvent === 'delete') {
        this.deleteService({id: this.selectedItem.id}).then(() => this.refresh());
      }
      this.closeModal();
    },
    routeToProperty(propertyId) {
      window.open(`/real_estate/edit/${propertyId}`, '_blank');
    },
    onSubmitted() {
      this.refresh();
      this.dialogs.newKeybox = false;
      this.dialogs.updateKeybox = false;
    }
  }
}
</script>
